import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { osNotificationAtom } from './utils/Global';
import { useAtom } from 'jotai';

const AppUrlListener: React.FC = () => {
    let history = useHistory();
    const [osNotification, setOsNotification] = useAtom(osNotificationAtom);
    useEffect(() => {
        const appUrlOpen = App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            const url = new URL(event.url);
            //TODO: Fix, seem to not working. Maybe because App is load asynchroneously in main.tsx
            setTimeout(() => {
                history.replace(url.pathname);
            }, 500);
        });

        return () => {
            appUrlOpen.then((appUrlOpen) => appUrlOpen.remove());
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (osNotification.notification) {
            if (osNotification.notification.launchURL) {
                const url = new URL(osNotification.notification.launchURL);
                history.replace(url.pathname);
            }
            setOsNotification({ notification: null });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [osNotification.notification]);

    return null;
};

export default AppUrlListener;
